module.exports = __webpack_public_path__ + "img/tu.310ce977.svg";